// apollo.ts
import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';  // ✅ add this
import { onError } from '@apollo/client/link/error';
import { useAuthStore } from '@/stores';
import { router } from '@/router';
import { fetchWrapper } from '@/helpers';

// Derived from fetchWrapper.url so the REST base and the GraphQL endpoint
// always point at the same backend (edit VITE_API_URL / fetch-wrapper.js
// in one place instead of two).
const httpLink = new HttpLink({
  uri: `${fetchWrapper.url}graphql`,
  // ✅ NO custom fetch — let Apollo handle body/headers
});

// ✅ Auth headers via setContext (correct pattern)
const authLink = setContext((_, { headers }) => {
  const authStore = useAuthStore();
  const token = authStore.user?.token;
  const platform = localStorage.getItem('platform');

  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(platform ? { platform } : {}),
    },
  };
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach((error) => {
      if (error.extensions?.code === 'UNAUTHENTICATED') {
        const authStore = useAuthStore();
        authStore.logout();
        router.push('/account/login');
      }
      console.error(`[GraphQL error]: ${error.message}`);
    });
  }
  if (networkError) {
    if (networkError.message && (networkError.message.includes('Store reset') || networkError.message.includes('store was reset'))) {
      return;
    }
    console.error(`[Network error]: ${networkError}`);
  }
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: errorLink.concat(authLink.concat(httpLink)), // ✅ correct order
});